import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "../../services/api-client.service";
import { IVerksamhetshandelseRequest, IVerksamhetshandelseResponse } from "./contracts/verksamhetshandelse";

@Injectable({
    providedIn: "root"
})

export class VerksamhetshandelseService {
    url: string;

    private readonly http = inject(ApiClientService);

    constructor() {
        this.url  = "verksamhetshandelse/";
    }

    getVerksamhetshandelse(request: IVerksamhetshandelseRequest): Observable<IVerksamhetshandelseResponse[]> {
        return this.http.post<IVerksamhetshandelseRequest, IVerksamhetshandelseResponse[]>(this.url, request);
    }
}
